export const OHL = {
    name: 'DV 256B TS OBRENOVAC - TENT A (od G-2)',
    voltage: '220',
    regionCode: 'BGD',
    stanice: [{name: 'OBRENOVAC', position: {lat: 44.6651, lng: 20.1688}}],
    position: 'S',
    stubovi: [
        { index: 1, name: 'P 03', lat: 44.6663 , lng: 20.1709, sys: 1, portal: true},
        { index: 2, name: '01', lat: 44.6671 , lng: 20.1705, sys: 2},
        { index: 3, name: '02', lat: 44.6692 , lng: 20.1707, sys: 2},
        { index: 4, name: '03', lat: 44.6701 , lng: 20.1671, sys: 2},
        { index: 5, name: '04', lat: 44.6707 , lng: 20.1648, sys: 2},
        { index: 6, name: '05', lat: 44.6713 , lng: 20.1625, sys: 2},
        { index: 7, name: 'P-99', lat: 44.6718 , lng: 20.1611, sys: 1, portal: true}
    ],
    rasponi: [
        { name: 'P-04 - 1', position: [{ lat: 44.6662 , lng: 20.1707 }, { lat: 44.6671 , lng: 20.1705 }] },
        { name: '1 - 2', position: [{ lat: 44.6671 , lng: 20.1705 }, { lat: 44.6692 , lng: 20.1707 }] },
        { name: '2 - 3', position: [{ lat: 44.6692 , lng: 20.1707 }, { lat: 44.6701 , lng: 20.1671 }] },
        { name: '3 - 4', position: [{ lat: 44.6701 , lng: 20.1671 }, { lat: 44.6707 , lng: 20.1648 }] },
        { name: '4 - 5', position: [{ lat: 44.6707 , lng: 20.1648 }, { lat: 44.6713 , lng: 20.1625 }] },
        { name: '5 - P-99', position: [{ lat: 44.6713 , lng: 20.1625 }, { lat: 44.6717 , lng: 20.1611 }] }
    ]
}
